module.exports = __webpack_public_path__ + "static/partner-dell-d6842dd05cc61a3a452838083cae501d.png";